export default "__VITE_ASSET__9bbc1bce__"